
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"18","height":"18","fill":"#fff"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"clip-path":"url(#clip0_1248_685)"}},[_c('path',{attrs:{"d":"M0 8.596v-.75l6 5.1-5.922 4.512A.878.878 0 010 17.096v-8.5zm.023-2.228c.128-.488.839-.801 1.234-1.074V3.201c0-.233.095-.457.265-.622.17-.165.4-.257.639-.257h3.386L8.779.084a.498.498 0 01.564.003l3.176 2.235h3.316c.24 0 .47.092.639.257.17.165.265.389.265.622v2.087c.425.293 1.256.692 1.256 1.244v.022l-2.156 1.77V3.199H2.161v4.98L.023 6.368zM18 8.025v9.071c0 .21-.075.415-.214.576l-5.98-4.572L18 8.025zM16.342 18H1.245l5.643-4.3 1.68 1.429a.587.587 0 00.776-.013l1.556-1.273L16.337 18h.004z"}}),_c('path',{attrs:{"d":"M12.689 7.318l-.703-.11a3.052 3.052 0 00-.318-.764l.421-.573a.372.372 0 00-.036-.484l-.438-.437a.369.369 0 00-.483-.036l-.573.42a2.931 2.931 0 00-.766-.32l-.109-.7A.374.374 0 009.313 4h-.62a.38.38 0 00-.37.315l-.106.698a2.994 2.994 0 00-.772.321l-.573-.42a.369.369 0 00-.484.036l-.437.437a.372.372 0 00-.037.484l.421.573c-.14.238-.248.496-.318.765l-.702.109a.374.374 0 00-.315.37v.62c0 .182.136.338.315.367l.702.11c.073.271.179.533.318.771l-.42.573a.368.368 0 00.036.48l.437.44c.133.13.335.146.484.037l.573-.42c.238.142.497.248.765.317l.11.702c.03.18.185.315.37.315h.62a.382.382 0 00.37-.315l.11-.702c.272-.072.53-.175.765-.317l.573.42c.15.11.358.093.484-.036l.437-.44a.368.368 0 00.037-.48l-.421-.574c.14-.238.249-.5.318-.771l.702-.11A.368.368 0 0013 8.308v-.62a.377.377 0 00-.315-.37h.004zM9.002 9.55a1.55 1.55 0 110-3.103c.858 0 1.55.695 1.55 1.55 0 .854-.696 1.553-1.55 1.553z"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_1248_685"}},[_c('path',{attrs:{"d":"M0 0h18v18H0z"}})])])])
          )
        }
      }
    